/* eslint-disable import/prefer-default-export */
import icon from "./icon";
import { OrangeKitBitcoinProvider } from "../bitcoin-wallet-provider";
import { createOrangeKitConnector } from "../connector";
export function getOrangeKitUnisatConnector({ rpcUrl, chainId, relayApiKey, }) {
    const bitcoinWalletProvider = new OrangeKitBitcoinProvider(window.unisat);
    return () => createOrangeKitConnector("orangekit-unisat", "Unisat", icon, rpcUrl, chainId, bitcoinWalletProvider, relayApiKey);
}
//# sourceMappingURL=connector.js.map